import "./NewCustomers.scss";
import {
  CloseIcon,
  BusinessIcon,
  UserIcon,
  MapPinIcon,
  StarIcon,
} from "../../../../../shared/margincalculator/components/icons/Icon";
import { useState } from "react";

interface NewCustomersProps {
  onClose: () => void;
}

type TabType = "firma" | "person" | "adresse" | "optionen";

function NewCustomers({ onClose }: NewCustomersProps) {
  const [activeTab, setActiveTab] = useState<TabType>("firma");

  return (
    <div className="new-customer-overlay" onClick={onClose}>
      <div className="new-customer-modal" onClick={(e) => e.stopPropagation()}>
        <button className="new-customer-modal__close" onClick={onClose}>
          <CloseIcon />
        </button>

        <header className="new-customer-modal__header">
          <h2>Neuen Kunden anlegen</h2>
          <p>
            Füllen Sie die Kundendaten aus. Nur der Firmenname ist erforderlich.
          </p>
        </header>

        <nav className="new-customer-modal__tabs">
          <button
            className={`new-customer-modal__tab ${activeTab === "firma" ? "new-customer-modal__tab--active" : ""}`}
            onClick={() => setActiveTab("firma")}
          >
            <BusinessIcon /> Firma
          </button>
          <button
            className={`new-customer-modal__tab ${activeTab === "person" ? "new-customer-modal__tab--active" : ""}`}
            onClick={() => setActiveTab("person")}
          >
            <UserIcon /> Person
          </button>
          <button
            className={`new-customer-modal__tab ${activeTab === "adresse" ? "new-customer-modal__tab--active" : ""}`}
            onClick={() => setActiveTab("adresse")}
          >
            <MapPinIcon /> Adresse
          </button>
          <button
            className={`new-customer-modal__tab ${activeTab === "optionen" ? "new-customer-modal__tab--active" : ""}`}
            onClick={() => setActiveTab("optionen")}
          >
            <StarIcon /> Optionen
          </button>
        </nav>

        <div className="new-customer-modal__content">
          {activeTab === "firma" && (
            <>
              <div className="new-customer-modal__form-group">
                <label>Firmenname *</label>
                <input type="text" placeholder="Muster GmbH" />
              </div>
              <div className="new-customer-modal__form-group">
                <label>Branche</label>
                <input type="text" placeholder="IT & Telekommunikation" />
              </div>
              <div className="new-customer-modal__form-group">
                <label>Notizen</label>
                <textarea placeholder="Interne Notizen zum Kunden..."></textarea>
              </div>
            </>
          )}

          {activeTab !== "firma" && (
            <div
              style={{ padding: "2rem", textAlign: "center", color: "#999" }}
            >
              In Kürze verfügbar...
            </div>
          )}
        </div>

        <footer className="new-customer-modal__footer">
          <button
            className="new-customer-modal__btn new-customer-modal__btn--cancel"
            onClick={onClose}
          >
            Abbrechen
          </button>
          <button className="new-customer-modal__btn new-customer-modal__btn--submit">
            Erstellen
          </button>
        </footer>
      </div>
    </div>
  );
}

export default NewCustomers;
